// extracted by css-extract-rspack-plugin
export default {"disclaimer":"In816r","discountinued-plan-disclaimer":"Gxi1Oo","discountinuedPlanDisclaimer":"Gxi1Oo"};